import React, { Component } from 'react';
import Parse from 'parse';
import { Link, Redirect} from "react-router-dom";
import {getUrlVariable} from './utilities';
import {propertyOptions} from './propertyConfig';
import ParseEditableInput from './components/parseEditableInput'
import ParseEditableSelect from './components/parseEditableSelect'
import ParseEditableTextarea from './components/parseEditableTextarea'
import ParseEditableBoolean from './components/parseEditableBoolean'

export default class EditUnit extends Component {
  constructor(props) {
      super(props);
      this.state = {}
  }
  componentDidMount = () =>{
    var id = this.state.id;
	  var Query = Parse.Object.extend("Units");
    var query = new Parse.Query(Query);
    query.get(getUrlVariable("id"),{
      success:(result) => {
        this.setState({
          result:result,
          id: result.id
        })
      }
    });
  }
  deleteUnit = () =>{
    var id = this.state.id;
	  var Query = Parse.Object.extend("Units");
    var query = new Parse.Query(Query);
    query.get(getUrlVariable("id"),{
      success:(result) => {
        result.destroy()
        this.setState({
          deleted:true
        })
      }
    });
  }
  render() {
    if(!this.state.result) return null;
    if(this.state.deleted) return <Redirect to={'/units'} />;
    return (
      <div>
        <div className="row">
          <div className="back-button">
            <Link to={'/'}>
              <img className="full-width" src="img/back-black.png" alt="back" />
            </Link>
          </div>
        </div>
        <div className="max-width-container medium-left-padding">
          <h1 className="no-margin uppercase"> Edit {this.state.result.attributes.unit}</h1>
          <div>
            {propertyOptions && propertyOptions.map((option) =>{
              return(
                <div className="medium-top-margin">
                  <h2>{option.key}</h2>
                  {option.value && option.valueType == "select" && option.isBoolean == true &&
                    <ParseEditableBoolean
                      parseclass="Units"
                      parseobjectid={this.state.id}
                      parsekey={option.value}
                      parsevalue={this.state.result.attributes[option.value]}
                    />
                  }
                  {option.value && option.valueType == "select" && option.isBoolean == false &&
                    <ParseEditableSelect
                      parseclass="Units"
                      parseobjectid={this.state.id}
                      parsekey={option.value}
                      options={option.selectOptions}
                      parsevalue={this.state.result.attributes[option.value]}
                    />
                  }
                  {option.valueType && option.valueType == "input" &&
                    <ParseEditableInput
                      parseclass="Units"
                      parseobjectid={this.state.id}
                      parsekey={option.value}
                      parsevalue={this.state.result.attributes[option.value]}
                    placeholder="..." />
                  }
                  {option.description &&
                    <ParseEditableTextarea
                      parseclass="Units"
                      parseobjectid={this.state.id}
                      parsekey={option.description}
                      parsevalue={this.state.result.attributes[option.description]}
                    placeholder="Enter a description..." />
                  }
                </div>
              )})}
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/editUnit.js